var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{staticClass:"align-items-center justify-content-center",attrs:{"href":"#"}})
}
var staticRenderFns = []

export { render, staticRenderFns }